import _ from 'underscore';

function AdmissionGroupCheckInPanelCtrl($scope, $panelInstance, venue, date, admissionGroup, colorService, admissionGroupService, alertService, sdkUtils, ticketService, $q, dateUtilsService) {
  if (!admissionGroup) throw new Error('admissionGroup is required');

  _initScope();

  function _initScope() {
    $scope.admissionGroup = admissionGroup;
    $scope.loading = false;
    $scope.venue = venue;
    $scope.venueBrandColors = $scope.venue.branding ? {
      primaryColor: $scope.venue.branding.primaryColor ? colorService.rgbToHex($scope.venue.branding.primaryColor.red, $scope.venue.branding.primaryColor.green, $scope.venue.branding.primaryColor.blue) : null //eslint-disable-line
    } : {};
    $scope.date = date;
    $scope.admissionGroupCheckInForm = {
      male: $scope.admissionGroup.guestsCheckedInMale || 0,
      female: $scope.admissionGroup.guestsCheckedInFemale || 0,
      unisex: $scope.admissionGroup.guestsCheckedInUnisex || 0
    };

    //if we haven't checked in yet, prefill with the expected counts
    if ($scope.admissionGroup.status !== 'CHECKED_IN_FULL') {
      $scope.admissionGroupCheckInForm.unisex = $scope.admissionGroup.guestsExpectedUnisex;
      $scope.admissionGroupCheckInForm.female = $scope.admissionGroup.guestsExpectedFemale;
      $scope.admissionGroupCheckInForm.male = $scope.admissionGroup.guestsExpectedMale;
    }

    if (admissionGroup.type === 'TICKET') {
      getTicketsByAdmissionGroupId(admissionGroup.id);
    }

    $scope.checkInAdmissionGroup = function(angularForm, all = false, $event) {
      if ($event) $event.preventDefault();

      $scope.submitted = true;

      if (!angularForm.$valid) return null;

      $scope.saving = true;

      if ($scope.admissionGroup.type !== 'TICKET') {
        //nothing has changed so don't re-save
        if ($scope.admissionGroupCheckInForm.unisex === $scope.admissionGroup.guestsCheckedInUnisex &&
          $scope.admissionGroupCheckInForm.female === $scope.admissionGroup.guestsCheckedInFemale &&
          $scope.admissionGroupCheckInForm.male === $scope.admissionGroup.guestsCheckedInMale) {
          $scope.saving = false;

          return $q.resolve()
            .then(() => {
              $panelInstance.close({
                admissionGroup: $scope.admissionGroup
              });
            });
        }

        const checkinData = {
          type: 'CHECK_IN'
        };

        checkinData.unisex = $scope.admissionGroupCheckInForm.unisex - $scope.admissionGroup.guestsCheckedInUnisex;
        checkinData.females = $scope.admissionGroupCheckInForm.female - $scope.admissionGroup.guestsCheckedInFemale;
        checkinData.males = $scope.admissionGroupCheckInForm.male - $scope.admissionGroup.guestsCheckedInMale;

        return admissionGroupService.performActionById($scope.admissionGroup.id, checkinData)
          .then(result => {
            $panelInstance.close({
              admissionGroup: result
            });

            $scope.saving = false;
          })
          .catch(error => {
            $scope.saving = false;

            alertService.error(sdkUtils.getErrorFromResponse(error));
          });
      }

      const checkedTickets = _.where($scope.tickets, {
        checked: true,
        checkedIn: false
      });

      if (!checkedTickets || !checkedTickets.length) {
        $scope.saving = false;
        return null;
      }

      const promises = checkedTickets.map(ticket => {
        return ticketService.checkInById(ticket.id, {
          venueId: $scope.venue.id,
          date: dateUtilsService.toUTCMomentWithoutTime($scope.date)
        });
      });

      return $q.all(promises)
        .then(() => {
          return admissionGroupService.readById(admissionGroup.id);
        })
        .then(result => {
          _.extend(admissionGroup, result);

          $panelInstance.close({
            admissionGroup
          });

          $scope.saving = false;
        })
        .catch(error => {
          $scope.saving = false;

          alertService.error(sdkUtils.getErrorFromResponse(error));
        });
    };

    $scope.closePanel = function($event) {
      if ($event) $event.preventDefault();

      $panelInstance.close(false);
    };

    $scope.updateGuestCount = function(key, amount, $event) {
      if ($event) $event.preventDefault();

      if ($scope.admissionGroupCheckInForm[key] === 0 && amount === -1) return;

      $scope.admissionGroupCheckInForm[key] += amount;
    };
  }

  function getTicketsByAdmissionGroupId(admissionGroupId) {
    if (!admissionGroupId) throw new Error('admissionGroupId');

    $scope.loading = true;

    return ticketService.listByAdmissionGroupId(admissionGroupId)
      .then(tickets => {
        $scope.tickets = tickets;

        $scope.loading = false;
      })
      .catch(error => {
        $scope.loading = false;

        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }
}

AdmissionGroupCheckInPanelCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'venue',
  'date',
  'admissionGroup',
  'colorService',
  'jsSdk.admissionGroup',
  'alertService',
  'jsSdk.utils',
  'jsSdk.ticket',
  '$q',
  'dateUtilsService'
];

export default AdmissionGroupCheckInPanelCtrl;



// WEBPACK FOOTER //
// ./src/panels/admissionGroupCheckIn/controller.js